var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"login","light":""}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('LoginForm')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }